import React, { Component } from 'react';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css';
import IntlMessageFormat from 'intl-messageformat';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0
THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.
See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') { return; }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".stars-module_stars__2wzth {\n  display: inline-flex;\n  align-items: baseline;\n  font-size: 1.1em;\n  touch-action: none; }\n  .stars-module_stars__2wzth i.icons {\n    margin-right: 0.33ex; }\n    @media only screen and (max-width: 599px) {\n      .stars-module_stars__2wzth i.icons {\n        font-size: 1.25em;\n        margin-right: 0.5ex; } }\n    .stars-module_stars__2wzth i.icons i.icon:first-child {\n      margin-right: 0; }\n    .stars-module_stars__2wzth i.icons:hover {\n      cursor: pointer; }\n    .stars-module_stars__2wzth i.icons i.icon.invisible {\n      visibility: hidden; }\n\n.stars-module_averageLabel__1srjU {\n  margin-left: 1.5em;\n  color: var(--light-text-color);\n  font-weight: 300; }\n";
var s = {"stars":"stars-module_stars__2wzth","averageLabel":"stars-module_averageLabel__1srjU"};
styleInject(css);

function Star(props) {
    var updatedEvents = {};
    Object.entries(props.events).forEach(function (handler) {
        updatedEvents[handler[0]] = function (event) {
            event.preventDefault();
            event.stopPropagation();
            handler[1](props.i);
        };
    });
    return (React.createElement("i", __assign({ className: 'ui icons' }, updatedEvents),
        React.createElement("i", { className: (props.starColor ? props.starColor : '') + " " + (props.inverted ? 'inverted' : '') + " outline star icon" }),
        React.createElement("i", { className: (props.starColor ? props.starColor : '') + " " + (props.inverted ? 'inverted' : '') + " " + props.starClass + " star icon" })));
}

var defaultNumberOfStars = 5;
var Stars = (function (_super) {
    __extends(Stars, _super);
    function Stars(props) {
        var _this = _super.call(this, props) || this;
        _this.onMouseLeave = function (enteredRating) {
            _this.setState({
                activeStar: -1
            });
        };
        _this.onMouseEnter = function (enteredRating) {
            _this.setState({
                activeStar: enteredRating
            });
        };
        _this.state = {
            activeStar: -1
        };
        return _this;
    }
    Stars.prototype.render = function () {
        var starArray = [];
        var additionalHalfStar = false;
        var floorStars = 0;
        var events = {
            onTouchEnd: this.props.clickHandler,
            onClick: this.props.clickHandler
        };
        if (window.matchMedia('(hover: hover)').matches) {
            events = __assign({}, events, { onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave });
        }
        if (this.props.averageRating) {
            floorStars = Math.floor(this.props.averageRating);
            if (this.props.averageRating &&
                this.props.averageRating - floorStars >= 0.25 &&
                this.props.averageRating - floorStars < 0.75) {
                additionalHalfStar = true;
            }
            if (this.props.averageRating &&
                this.props.averageRating - floorStars >= 0.75) {
                floorStars = floorStars + 1;
            }
        }
        for (var i = 1; i <= (this.props.starAmount || defaultNumberOfStars); i++) {
            var starClass = 'invisible';
            if (this.state.activeStar >= i ||
                this.props.currentlySelectedRating >= i) {
                starClass = '';
            }
            if (this.props.votingIsOver) {
                starClass = 'over';
                if (floorStars < i) {
                    starClass = 'invisible';
                    if (additionalHalfStar && i - 1 === floorStars) {
                        starClass = 'over half';
                    }
                }
            }
            starArray.push(React.createElement(Star, { key: "star-" + i, i: i, inverted: this.props.inverted, events: events, starColor: this.props.starColor, starClass: starClass }));
        }
        return (React.createElement("a", { className: "stars " + s.stars + " " + (this.props.starColor ? this.props.starColor : '') + " " + (this.props.inverted ? 'inverted' : '') },
            starArray,
            this.props.votingIsOver && this.props.averageRating && (React.createElement("span", { className: "label average " + s.averageLabel + " " + (this.props.inverted ? 'inverted' : '') },
                "\u2300",
                ' ',
                this.props.averageRating.toLocaleString('fr-CH', {
                    maximumFractionDigits: 1,
                    minimumFractionDigits: 1
                })))));
    };
    Stars.defaultProps = {
        starAmount: defaultNumberOfStars,
        inverted: false,
        currentlySelectedRating: -1,
        votingIsOver: false
    };
    return Stars;
}(Component));

var css$1 = "@media screen and (max-width: 599px) {\n  .question-module_question__1lbLA {\n    margin-bottom: 0.5ex;\n    font-weight: 500 !important; } }\n\n.question-module_questionGroup__2gQQY {\n  font-size: var(--font-size); }\n  @media screen and (max-width: 599px) {\n    .question-module_questionGroup__2gQQY {\n      margin-bottom: 1ex; }\n      .question-module_questionGroup__2gQQY:last-child {\n        margin-bottom: 0; } }\n";
var styles = {"question":"question-module_question__1lbLA","questionGroup":"question-module_questionGroup__2gQQY"};
styleInject(css$1);

var Question = (function (_super) {
    __extends(Question, _super);
    function Question() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            currentlySelectedRating: -1
        };
        _this.handleClick = function (selectedRating) {
            if (!_this.props.votingIsOver) {
                _this.setState({
                    currentlySelectedRating: selectedRating
                });
                _this.props.ratingHandler(_this.props.question, selectedRating);
            }
        };
        return _this;
    }
    Question.prototype.render = function () {
        return (React.createElement("tr", { className: styles.questionGroup },
            React.createElement("td", { className: styles.question }, this.props.question),
            React.createElement("td", { className: "single line right aligned" },
                React.createElement(Stars, { averageRating: this.props.averageRating, clickHandler: this.handleClick, inverted: this.props.inverted, currentlySelectedRating: this.state.currentlySelectedRating, starAmount: this.props.starAmount, starColor: this.props.starColor, votingIsOver: this.props.votingIsOver }))));
    };
    Question.defaultProps = {
        inverted: false,
        starAmount: 5,
        votingIsOver: false
    };
    return Question;
}(Component));

var css$2 = ".styles-module_userFeedback__2oH3I {\n  --font-size: 0.9rem; }\n  .styles-module_userFeedback__2oH3I .ui.table {\n    background: none !important;\n    margin: 0; }\n    @media only screen and (max-width: 599px) {\n      .styles-module_userFeedback__2oH3I .ui.table:not(.unstackable) .right.aligned {\n        text-align: left; } }\n\n.styles-module_feedbackText__2MypS,\n.styles-module_mainQuestion__38Vzb {\n  font-size: var(--font-size);\n  color: var(--text-color); }\n\n.styles-module_feedbackText__2MypS {\n  margin-bottom: 1ex; }\n\n.styles-module_mainQuestion__38Vzb {\n  font-weight: 700; }\n\n@media screen and (max-width: 599px) {\n  .table.inverted tr {\n    padding: var(--vertical-padding) 0 !important; } }\n";
var s$1 = {"userFeedback":"styles-module_userFeedback__2oH3I","feedbackText":"styles-module_feedbackText__2MypS","mainQuestion":"styles-module_mainQuestion__38Vzb"};
styleInject(css$2);

var DB_ENDPOINT = 'https://ta-user-feedback.firebaseio.com/v2/stories';
var MESSAGES = {
    de: {
        answerText: 'Die meisten Leserinnen und Leser bewerten den Beitrag als sehr gut.' +
            ' Das freut uns.',
        questions: [
            'Wie lehrreich war der Beitrag?',
            'Wie unterhaltsam war er?',
            'Wie gefällt Ihnen die Gestaltung?'
        ],
        title: 'Wie war’s?',
        feedback: {
            thanks: 'Vielen Dank für Ihre Bewertung.',
            stats: 'Bisher {respondentCount, plural, =0 {hat noch niemand} one' +
                ' {hat <strong>eine Person</strong>} other {haben <strong>#' +
                ' Personen</strong>}}' +
                ' abgestimmt.'
        },
        error: {
            noSave: 'Vielen Dank für Ihre Bewertung! Leider gab es ein Problem' +
                ' mit der Kommunikation mit der Datenbank, und Ihre Bewertung konnte' +
                ' nicht gespeichert werden. Bitte versuchen Sie es' +
                ' später erneut.',
            noDownload: 'Vielen Dank für Ihre Stimme. Leider konnten die' +
                ' Bewertungen der anderen Leserinnen und Leser nicht' +
                ' heruntergeladen werden. Wir können Ihnen deshalb im Moment' +
                ' die durchschnittliche Bewertung nicht anzeigen.'
        },
        submit: 'Bewerten'
    },
    fr: {
        answerText: 'Une majorité de lectrices et lecteurs estime que ce contenu est très bon. Nous en sommes reconnaissants.',
        questions: [
            'Ce contenu était-il informatif?',
            'Etait-il divertissant?',
            'La mise en forme vous plaît-elle?'
        ],
        title: 'Comment votez-vous cette contribution?',
        feedback: {
            thanks: 'Merci pour votre évaluation.',
            stats: "{respondentCount, plural, =0 {Personne n'a encore} one {<strong>Une" +
                ' personne</strong> a} other {<strong># personnes</strong> ont}} noté ce' +
                ' contenu.'
        },
        error: {
            noSave: "Merci beaucoup pour votre évaluation! Malheureusement, la communication avec la base de données n'a pu être établie et vos notes n'ont pu être prises en compte. Nous vous prions de réessayer un peu plus tard.",
            noDownload: "Merci beaucoup pour votre évaluation. Malheureusement, les notes des autres utilisateurs n'ont pu être téléchargées. C'est la raison pour laquelle nous ne pouvons pas afficher de moyennes pour le moment."
        },
        submit: 'Confirmer'
    }
};
var UserFeedback = (function (_super) {
    __extends(UserFeedback, _super);
    function UserFeedback(props) {
        var _this = _super.call(this, props) || this;
        _this.submitHandler = function () {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Interactions',
                event_action: 'click',
                event_label: 'region: userVoteButtonClicked/'
            });
            _this.pushVotesToDB(_this.state.personalVotes)
                .then(function (downloadedValues) {
                _this.setVoteResults(downloadedValues);
                _this.setState({
                    votingIsOver: true
                });
            })
                .catch(function (error) {
                console.log(error.message, error);
            });
        };
        _this.ratingHandler = function (question, rating) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Interactions',
                event_action: 'click',
                event_label: 'region: userVote/' + rating
            });
            _this.setState(function (state) {
                var questionRatings = state.personalVotes;
                var questions = _this.props.questions ||
                    (_this.props.locale &&
                        MESSAGES[_this.props.locale].questions);
                questionRatings[questions.indexOf(question)] = rating;
                return {
                    personalVotes: questionRatings
                };
            }, _this.checkIfSubmitReady);
        };
        var questions = props.questions ||
            (props.locale && MESSAGES[props.locale].questions);
        _this.state = {
            personalVotes: questions.map(function () { return -1; }),
            readyToSubmit: false,
            hasError: false,
            votingIsOver: !!localStorage.getItem('vote-' + _this.props.articleId)
        };
        return _this;
    }
    UserFeedback.prototype.pushVotesToDB = function (ratings) {
        var _this = this;
        return fetch(DB_ENDPOINT + "/" + this.props.articleId + ".json", {
            headers: { 'X-Firebase-ETag': 'true' }
        })
            .then(function (originalValueResponse) {
            return originalValueResponse.json().then(function (previousValue) {
                if (!originalValueResponse.ok) {
                    throw Error(originalValueResponse.statusText);
                }
                var etag = originalValueResponse.headers.get('ETag');
                if (!previousValue) {
                    return fetch(DB_ENDPOINT + "/" + _this.props.articleId + ".json", {
                        method: 'PUT',
                        body: JSON.stringify({
                            p: 1,
                            v: ratings
                        })
                    }).then(function (writeResponse) {
                        if (!writeResponse.ok) {
                            throw Error(writeResponse.statusText);
                        }
                        localStorage.setItem('vote-' + _this.props.articleId, JSON.stringify(ratings));
                        return writeResponse.json();
                    });
                }
                return _this.writeToDatabase(ratings, previousValue, etag);
            });
        })
            .catch(function (error) {
            console.log(error.message, error);
            _this.setState({
                hasError: true,
                errorText: 'error.noSave'
            });
            return { p: 1, v: ratings };
        });
    };
    UserFeedback.prototype.writeToDatabase = function (ratings, previousValue, eTag) {
        var _this = this;
        return fetch(DB_ENDPOINT + "/" + this.props.articleId + ".json", {
            headers: eTag ? { 'if-match': eTag } : undefined,
            method: 'PUT',
            body: JSON.stringify(this.updatePreviousValuesWithNewVotes(previousValue, ratings))
        }).then(function (writeResponse) {
            return writeResponse.json().then(function (json) {
                var responseStatus = writeResponse.status;
                if (responseStatus === 412) {
                    var newValue = json;
                    var newEtag = writeResponse.headers.get('ETag');
                    return _this.writeToDatabase(ratings, newValue, newEtag);
                }
                if (responseStatus === 200) {
                    localStorage.setItem('vote-' + _this.props.articleId, JSON.stringify(ratings));
                    return json;
                }
            });
        });
    };
    UserFeedback.prototype.updatePreviousValuesWithNewVotes = function (previousValue, ratings) {
        var cumulativeVotes = previousValue.v.map(function (previousVote, index) { return previousVote + ratings[index]; });
        return {
            p: previousValue.p + 1,
            v: cumulativeVotes
        };
    };
    UserFeedback.prototype.checkIfSubmitReady = function () {
        this.setState(function (state) {
            return { readyToSubmit: state.personalVotes.every(function (value) { return value > 0; }) };
        });
    };
    UserFeedback.prototype.setVoteResults = function (downloadedValues) {
        var averages = downloadedValues.v.map(function (cumulativeVote) { return cumulativeVote / downloadedValues.p; });
        var overallAverage = averages.reduce(function (previousValue, currentValue) { return previousValue + currentValue; }) / averages.length;
        this.setState({
            numberOfParticipants: downloadedValues.p,
            averageVotes: averages,
            overallAverage: overallAverage
        });
    };
    UserFeedback.prototype.setupTest = function (eventToTestFor, actionHandler) {
        window.document.documentElement.addEventListener(eventToTestFor, function onFirstInteraction(event) {
            event.preventDefault();
            event.stopPropagation();
            actionHandler(true);
            window.document.documentElement.removeEventListener(eventToTestFor, onFirstInteraction, false);
        }, false);
    };
    UserFeedback.prototype.componentDidMount = function () {
        var _this = this;
        if (localStorage.getItem('vote-' + this.props.articleId)) {
            return fetch(DB_ENDPOINT + "/" + this.props.articleId + ".json")
                .then(function (response) {
                return response.json().then(function (values) {
                    _this.setVoteResults(values);
                });
            })
                .catch(function (error) {
                console.log(error);
                _this.setState({
                    hasError: true,
                    errorText: 'error.noDownload'
                });
                _this.setVoteResults({
                    p: 1,
                    v: JSON.parse(localStorage.getItem('vote-' + _this.props.articleId) || '[]')
                });
            });
        }
    };
    UserFeedback.prototype.render = function () {
        var _this = this;
        var t = function (key) {
            return (_this.props[key] ||
                key
                    .split('.')
                    .reduce(function (messageList, prop) {
                    return messageList.hasOwnProperty(prop)
                        ? messageList[prop]
                        : 'TRANSLATED_STRING_NOT_FOUND: ' + key;
                }, MESSAGES[_this.props.locale || 'de']));
        };
        var respondentMessage = new IntlMessageFormat(t('feedback.stats'), this.props.locale + '-CH');
        var questions = t('questions');
        return (React.createElement("div", { className: "user-feedback interactive " + s$1.userFeedback + " " + this.props.className + " " + (this.props.inverted ? 'inverted' : '') },
            this.state.votingIsOver && !this.state.hasError && (React.createElement("div", { className: "feedback-text " + s$1.feedbackText + " " + (this.props.inverted &&
                    s$1.inverted) },
                React.createElement("span", null, t('feedback.thanks')),
                ' ',
                React.createElement("span", { dangerouslySetInnerHTML: {
                        __html: respondentMessage.format({
                            respondentCount: this.state.numberOfParticipants
                        })
                    } }),
                ' ',
                this.state.overallAverage &&
                    this.state.overallAverage >=
                        (this.props.starAmount || 5) * 0.8 && (React.createElement("span", null, t('answerText'))))),
            this.state.votingIsOver &&
                this.state.hasError &&
                this.state.errorText && (React.createElement("div", { className: 'feedback-text' }, t(this.state.errorText))),
            !this.state.votingIsOver && (React.createElement("div", { className: "header " + s$1.mainQuestion + " " + (this.props.inverted ? 'inverted' : '') + " " }, t('title'))),
            React.createElement("table", { id: 'vote-table', className: "ui interactive very basic " + (this.props.inverted ? 'inverted' : '') + " table" },
                React.createElement("tbody", null, questions.map(function (question, i) {
                    var avg = {};
                    if (_this.state.averageVotes) {
                        avg = {
                            averageRating: _this.state.averageVotes[i]
                        };
                    }
                    return (React.createElement(Question, __assign({ ratingHandler: _this.ratingHandler, starAmount: _this.props.starAmount, starColor: _this.props.starColor, question: question, votingIsOver: _this.state.votingIsOver }, avg, { inverted: _this.props.inverted, key: "question-" + i })));
                }))),
            !this.state.votingIsOver && (React.createElement("div", { className: "ui vertical very fitted center aligned " + (this.props.inverted ? 'inverted' : '') + " basic segment" },
                React.createElement("button", { onClick: this.submitHandler, className: "ui button " + (this.state.readyToSubmit === true ? '' : 'disabled') + " " + (this.props.inverted ? 'inverted' : '') + " " + this.props.starColor }, t('submit'))))));
    };
    UserFeedback.defaultProps = {
        className: '',
        inverted: false,
        locale: 'de',
        starAmount: 5,
        starColor: 'primary'
    };
    return UserFeedback;
}(Component));

export default UserFeedback;
export { UserFeedback };
//# sourceMappingURL=index.js.map
